module.exports = {
      id: "glyph:copy-file-usage",
      viewBox: "0 0 64 64",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#glyph:copy-file-usage",
      toString: function () {
        return this.url;
      }
    }